import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  policy: {
    color: theme.colorPalette.beige_25,
    fontWeight: 300,
    fontSize: 10
  },
  policyContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  paymentContainer: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1)
  },
  payment: {
    fontWeight: 300,
    lineHeight: 1.4
  },
  paymentSchedules: {
    marginBottom: theme.spacing(2)
  },
  tooltip: {
    fontWeight: 300,
    fontSize: 18
  },
  extendedInfo: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(4, 0),
    marginTop: theme.spacing(4)
  },
  coverageValue: {
    fontSize: 14,
    marginTop: theme.spacing(1)
  },
  remainingPayments: {
    composes: '$paymentContainer',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 400,
    color: theme.colorPalette.beige_25
  },
  highlightedNumber: {
    fontWeight: 600,
    color: theme.colorPalette.green_50
  },
  megaDownPayCard: {
    display: 'flex',
    gap: theme.spacing(2),
    padding: theme.spacing(4),
    backgroundColor: theme.colorPalette.green_100,
    marginTop: theme.spacing(2),
    color: theme.colors.white
  },
  icon: {
    width: 16,
    height: 16
  },
  effectiveDate: {
    fontSize: 16,
    lineHeight: '24px',
    color: theme.colorPalette.beige_25,
    fontWeight: 400,
    spacing: theme.spacing(0, 1)
  },
  editIcon: {
    width: 20,
    height: 20
  },
  editButton: {
    width: '24px',
    height: '20px'
  },
  header: {
    padding: theme.spacing(0),
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '16px',
    color: theme.colors.white
  },
  text: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '16px',
    color: theme.colors.white,
    padding: theme.spacing(1, 0)
  },
  inlineLink: {
    color: theme.colorPalette.orange_50,
    fontSize: 12,
    lineHeight: '16px',
    height: 16,
    padding: 0,
    cursor: 'pointer',
    textDecoration: 'underline'
  }
}));

export default useStyles;
